import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const BoxComponent = styled.div`
  min-width: 300px;
  width: 100%;
  background: #FFFFFF;
  box-shadow: ${props => props.theme.boxComponent.shadow || '2px 2px 4px 0 rgba(0, 0, 0, 0.35)'};
  border-radius: ${props => props.theme.boxComponent.borderRadius};
  border: ${props => props.theme.boxComponent.border};
  position: relative;
  z-index: 1;

  @media (min-width: 1025px) {
    margin-top: ${props => props.theme.boxComponent.marginTop};
    ${props => props.theme.boxComponent.stickyWithWideTeaser && props.hasTeaser && `
      position: sticky;
      top: ${props.theme.boxComponent.stickyTop};
      margin-bottom: ${props.theme.boxComponent.stickyBottomGap};
    `}
  }
`;

BoxComponent.defaultProps = {
  theme: {
    boxComponent: {
      borderRadius: '0'
    }
  }
}

export default class Box extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
    position: PropTypes.string,
    hasTeaser: PropTypes.bool
  };

  render () {
    return (
      <BoxComponent position={this.props.position} hasTeaser={this.props.hasTeaser}>
        {this.props.children}
      </BoxComponent>
    );
  }
}
